import React from 'react';

interface Resultado {
  orderId: string;
  error?: string;
}

interface ResultadosProps {
  exitosos: string[];
  fallidos: Resultado[];
}

const Resultados: React.FC<ResultadosProps> = ({ exitosos, fallidos }) => {
  if (exitosos.length === 0 && fallidos.length === 0) {
    return null;
  }

  return (
    <div className="mt-6 space-y-4">
      {exitosos.length > 0 && (
        <div className="bg-green-50 border border-green-200 rounded-lg p-4">
          <h3 className="text-green-800 font-semibold mb-2">Pedidos actualizados exitosamente:</h3>
          <ul className="list-disc list-inside text-green-700">
            {exitosos.map((id) => (
              <li key={id}>{id}</li>
            ))}
          </ul>
        </div>
      )}

      {fallidos.length > 0 && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <h3 className="text-red-800 font-semibold mb-2">Pedidos que no se pudieron actualizar:</h3>
          <ul className="list-disc list-inside text-red-700">
            {fallidos.map(({ orderId, error }) => (
              <li key={orderId}>
                <span className="font-medium">{orderId}</span>: {error}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Resultados; 